import { isBefore, sub, formatDistanceToNow } from 'date-fns'
import ptBRLocale from 'date-fns/locale/pt-BR'

const LS_FIXED_FRESH_DATE_TIME = 'fixed_fresh_date_time'

function createAndStoreCurrentDateTime() {
  const datetime = new Date()
  localStorage.setItem(LS_FIXED_FRESH_DATE_TIME, datetime.toISOString())

  return datetime
}

function getFreshDateTime() {
  const freshDateISOString = localStorage.getItem(LS_FIXED_FRESH_DATE_TIME)

  if (!freshDateISOString) {
    return createAndStoreCurrentDateTime()
  }

  const freshDate = new Date(freshDateISOString)
  const yesterday = sub(new Date(), { days: 1 })

  if (isBefore(freshDate, yesterday)) {
    return createAndStoreCurrentDateTime()
  }

  return freshDate
}

function formatDateToNow(date) {
  return formatDistanceToNow(date, {
    includeSeconds: false,
    locale: ptBRLocale,
  })
}

function formatFolderCompletedDate(date) {
  return new Date(date).toLocaleDateString('pt-BR')
}

export { getFreshDateTime, formatDateToNow, formatFolderCompletedDate }
